import moment from "moment";
import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { getDataAPI } from "../../../services/apiWrapper";

/*
  Every fee receipt of one student, reached from the Slips column on the
  center's student list. The list names each payment; the button beside it
  opens that receipt as a PDF.
*/
export default function StudentSlips() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [student, setStudent] = useState(null);
  const [slips, setSlips] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    let live = true;
    const load = async () => {
      try {
        const token = localStorage.getItem("centerToken");
        const res = await dispatch(getDataAPI(`center/student/fees/${id}`, token));
        if (!live) return;
        setStudent(res.data.data.student);
        setSlips(res.data.data.slips || []);
      } catch (e) {
        if (!live) return;
        setError(
          e.response?.data?.message || "Could not load the receipts for this student."
        );
      } finally {
        if (live) setLoading(false);
      }
    };
    load();
    return () => {
      live = false;
    };
  }, [dispatch, id]);

  return (
    <div className="mid-content-box">
      <div className="Title-box">
        <div className="row">
          <div className="col-md-6">
            <div className="BigTitle">Fee Receipts</div>
          </div>
          <div className="col-md-6 text-right">
            <Link to="/center/students" className="btn btn-comman">
              Back to Students
            </Link>
          </div>
        </div>
      </div>

      {student && (
        <div className="Widthdata">
          <div className="row" style={{ padding: "10px 15px" }}>
            <div className="col-md-4">
              <strong>Student</strong>
              <div>{student.name}</div>
            </div>
            <div className="col-md-4">
              <strong>Roll Number</strong>
              <div>{student.roll_number || "-"}</div>
            </div>
            <div className="col-md-4">
              <strong>Course</strong>
              <div>{student.course_name || "-"}</div>
            </div>
          </div>
        </div>
      )}

      <div className="Widthdata">
        <div className="Applicationdata s">
          <div className="row">
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th>Sr No.</th>
                    <th>Receipt No.</th>
                    <th>Fee Type</th>
                    <th>Amount</th>
                    <th>Date</th>
                    <th>Mode</th>
                    <th>Transaction ID</th>
                    <th>Slip</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="8">
                        <div className="text-center">
                          <Spinner animation="border" role="status" size="lg">
                            <span className="visually-hidden">Loading...</span>
                          </Spinner>
                        </div>
                      </td>
                    </tr>
                  ) : error ? (
                    <tr>
                      <td colSpan="8">{error}</td>
                    </tr>
                  ) : slips.length === 0 ? (
                    <tr>
                      <td colSpan="8">
                        No fee has been recorded for this student yet, so there is
                        no receipt to show.
                      </td>
                    </tr>
                  ) : (
                    slips.map((slip, index) => (
                      <tr key={slip.id}>
                        <td>{index + 1}</td>
                        <td>{slip.receipt_num || "-"}</td>
                        <td>{slip.fee_type}</td>
                        <td>Rs. {slip.total_fees}</td>
                        <td>
                          {slip.paid_at
                            ? moment(slip.paid_at).format("DD/MM/YYYY hh:mm A")
                            : "-"}
                        </td>
                        <td>
                          {slip.mode === "gateway" ? "Online" : slip.mode}
                        </td>
                        <td>{slip.trx_id || "-"}</td>
                        <td>
                          <a
                            className="btn btn-sm btn-comman"
                            href={slip.link}
                            target="_blank"
                            rel="noreferrer"
                          >
                            Slip
                          </a>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
